import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Initialize with 23h 56m 27s
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 56,
    seconds: 27
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        // Reset to 23:59:59 if it hits 0 to keep the urgency loop
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-bold text-gray-900 font-serif" aria-label="Tiempo restante de la oferta" data-id="element-36">
      <div className="flex flex-col items-center" data-id="element-37">
        <div className="bg-ocean-cream px-3 py-2 rounded-lg border border-gray-200 shadow-sm min-w-[60px] md:min-w-[80px] text-center" data-id="element-38">
          {format(timeLeft.hours)}
        </div>
        <span className="text-xs text-gray-500 mt-1 uppercase tracking-wider font-sans font-medium" data-id="element-39">
          hs
        </span>
      </div>
      <span className="text-gray-400 -mt-6" data-id="element-40">:</span>
      <div className="flex flex-col items-center" data-id="element-41">
        <div className="bg-ocean-cream px-3 py-2 rounded-lg border border-gray-200 shadow-sm min-w-[60px] md:min-w-[80px] text-center" data-id="element-42">
          {format(timeLeft.minutes)}
        </div>
        <span className="text-xs text-gray-500 mt-1 uppercase tracking-wider font-sans font-medium" data-id="element-43">
          min
        </span>
      </div>
      <span className="text-gray-400 -mt-6" data-id="element-44">:</span>
      <div className="flex flex-col items-center" data-id="element-45">
        <div className="bg-ocean-cream px-3 py-2 rounded-lg border border-gray-200 shadow-sm min-w-[60px] md:min-w-[80px] text-center" data-id="element-46">
          {format(timeLeft.seconds)}
        </div>
        <span className="text-xs text-gray-500 mt-1 uppercase tracking-wider font-sans font-medium" data-id="element-47">
          seg
        </span>
      </div>
    </div>;
}